<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppShell from '@/components/AppShell.vue'
import KioskShell from '@/components/KioskShell.vue'
import StagingBanner from '@/components/StagingBanner.vue'
import ToastHost from '@/components/ToastHost.vue'
import BefehlsPalette from '@/components/BefehlsPalette.vue'
import { useKioskHuelle } from '@/composables/useKioskHuelle'

const route = useRoute()
const showShell = computed(() => route.meta.shell !== false)
// Fullscreen-Routes (Editor) sollen exakt den Viewport füllen. Bei fester Höhe
// (h-svh) passen Staging-Banner + Editor zusammen genau hinein — sonst schob
// das Banner den h-svh-Editor um seine Höhe über den Rand (26px Seiten-Scroll,
// auf Staging sichtbar). Nicht-Fullscreen (Dashboard) behält min-h-svh und
// scrollt wie bisher.
const isFullscreen = computed(() => route.meta?.fullscreen === true)
// Kunden-Rolle bekommt die schlanke Kiosk-Hülle (Branding + nur ihr Werkzeug)
// statt des vollen Admin-Chrome. Warum die Hülle beim Abmelden stehen bleibt,
// steht in useKioskHuelle.
const isKiosk = useKioskHuelle()
</script>

<template>
  <div :class="[isFullscreen ? 'h-svh overflow-hidden' : 'min-h-svh', 'flex flex-col']">
    <StagingBanner />
    <div class="flex-1 min-h-0 flex flex-col">
      <template v-if="showShell">
        <KioskShell v-if="isKiosk">
          <RouterView />
        </KioskShell>
        <AppShell v-else>
          <RouterView />
        </AppShell>
      </template>
      <RouterView v-else />
    </div>
  </div>
  <ToastHost />
  <!-- Die Suche liegt über allem, auch über dem bildschirmfüllenden Editor. -->
  <BefehlsPalette />
</template>
